import ApplicationTabs from './ApplicationTabs';
import ApplicationsSearchInput from './ApplicationsSearchInput';
import ApplicationsFilter from './ApplicationsFilter';

const ApplicationsToolbar = () => {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-4 lg:flex-nowrap">
      <ApplicationTabs />
      <div className="flex w-full items-center gap-2 sm:w-auto">
        <ApplicationsSearchInput />
        <ApplicationsFilter />
      </div>
    </div>
  );
};

export default ApplicationsToolbar;
